import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export const CONTACT = {
  email: "info@leylakmarketing.com",
  phone: "+44 7537 185899",
  address: "1 Spencer Rd, Bromley BR1 3SU, United Kingdom",
  company: "Leylak Marketing Ltd",
};
